import type { ProbeTraceStep } from '@terra/shared-contracts-assets';
import { resolveProbeTraceStepPresentation } from './probe-trace-step-presentation.utils';

const PLAN_STEP_TITLE = 'update plan';
const PLAN_STEP_ID_PREFIXES = ['plan', 'update-plan', 'todo'] as const;

const isErrorStep = (step: ProbeTraceStep): boolean =>
  step.status === 'FAILED' || step.status === 'BLOCKED';

const isPlanStep = (step: ProbeTraceStep): boolean => {
  const title = step.title.trim().toLowerCase();
  const id = step.id.trim().toLowerCase();

  return (
    title === PLAN_STEP_TITLE ||
    PLAN_STEP_ID_PREFIXES.some((prefix) => id.startsWith(prefix))
  );
};

const resolveStepKind = (step: ProbeTraceStep) =>
  resolveProbeTraceStepPresentation({ step, hasHttpExchange: false });

const isReasoningStep = (step: ProbeTraceStep): boolean =>
  resolveStepKind(step) === 'reasoning';

export const shouldHideProbeStepInMinimizedView = ({
  step,
}: {
  step: ProbeTraceStep;
}): boolean => {
  if (isErrorStep(step)) {
    return false;
  }

  return resolveStepKind(step) === 'tool' || isPlanStep(step);
};

export const filterMinimizedProbeTraceSteps = ({
  steps,
}: {
  steps: ProbeTraceStep[];
}): ProbeTraceStep[] =>
  steps.filter((step, index) => {
    if (!isReasoningStep(step)) {
      return !shouldHideProbeStepInMinimizedView({ step });
    }

    if (isErrorStep(step)) {
      return true;
    }

    const nextActionStep = steps
      .slice(index + 1)
      .find((candidate) => !isReasoningStep(candidate));

    return nextActionStep
      ? !shouldHideProbeStepInMinimizedView({ step: nextActionStep })
      : true;
  });
